import * as Styles from "@universityofmaryland/web-styles-library";
import { LoadingState } from "../../states/loading.js";
import "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-elements-library";
import "@universityofmaryland/web-utilities-library/theme";
import { Announcer } from "../../states/announcer.js";
function createFetchHandlers(config) {
  const {
    fetchStrategy,
    helpers,
    baseProps,
    displayHandlers,
    layoutElement,
    isThemeDark,
    enableCategoryFallback = false
  } = config;
  const loadMore = async () => {
    const container = helpers.getContainer();
    const currentCount = helpers.getOffset();
    const totalEntries = helpers.getTotalEntries();
    const existingPagination = container.querySelector(
      `.${Styles.layout.alignment.block.center.className}`
    );
    existingPagination?.remove();
    const loading = new LoadingState({ isThemeDark });
    loading.show(container);
    const variables = fetchStrategy.composeApiVariables({
      ...baseProps,
      getOffset: helpers.getOffset
    });
    const feedData = await fetchStrategy.fetchEntries(variables);
    if (feedData) {
      loading.hide();
      await displayHandlers.displayResults({ feedData });
      const message = `Showing ${currentCount + feedData.length} of ${totalEntries} articles`;
      const existingAnnouncer = container.querySelector(
        '[role="status"]'
      );
      if (existingAnnouncer) {
        existingAnnouncer.textContent = message;
      } else {
        const announcer = new Announcer({ message });
        container.appendChild(announcer.getElement());
      }
    } else {
      loading.hide();
      displayHandlers.displayNoResults({
        message: "An error occurred while loading more results."
      });
    }
  };
  const start = async () => {
    const variables = fetchStrategy.composeApiVariables({
      ...baseProps,
      getOffset: helpers.getOffset
    });
    const count = await fetchStrategy.fetchCount(variables);
    if (count === 0) {
      if (enableCategoryFallback && baseProps.categories && baseProps.categories.length > 0) {
        const fallbackVariables = fetchStrategy.composeApiVariables({
          ...baseProps,
          categories: void 0,
          getOffset: helpers.getOffset
        });
        const fallbackCount = await fetchStrategy.fetchCount(fallbackVariables);
        if (fallbackCount && fallbackCount > 0) {
          helpers.setTotalEntries(fallbackCount);
          const fallbackData = await fetchStrategy.fetchEntries(
            fallbackVariables
          );
          if (fallbackData && fallbackData.length > 0) {
            let categoryNames = await fetchStrategy.fetchCategoryNames?.(
              baseProps.categories,
              baseProps.token
            );
            if (!categoryNames || categoryNames.length === 0) {
              categoryNames = baseProps.categories.map(
                (id) => id.split("-").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
              );
            }
            await displayHandlers.displayResultStart({
              feedData: fallbackData,
              layoutElement,
              isFallback: true,
              categoryNames
            });
            return;
          }
        }
      }
      displayHandlers.displayNoResults({});
      return;
    }
    if (count === null) {
      displayHandlers.displayNoResults({
        message: "An error occurred while fetching the data."
      });
      return;
    }
    if (count) {
      helpers.setTotalEntries(count);
    }
    const feedData = await fetchStrategy.fetchEntries(variables);
    if (feedData && feedData.length > 0) {
      await displayHandlers.displayResultStart({
        feedData,
        layoutElement
      });
    } else {
      displayHandlers.displayNoResults({
        message: "An error occurred while fetching the data."
      });
    }
  };
  return {
    start,
    loadMore
  };
}
export {
  createFetchHandlers
};
//# sourceMappingURL=fetchHandler.js.map
